"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProps = void 0;
var imgix_1 = require("../imgix");
var utils_1 = require("../utils");
var getProps = function (path, config, options) {
    var sizes = (0, utils_1.getSizes)(config);
    var maxWidths = (0, utils_1.getMaxWidths)(config);
    var srcSet = maxWidths.map(function (w) {
        return "".concat((0, imgix_1.buildUrl)(path, __assign({ w: w }, options)), " ").concat(w, "w");
    });
    return {
        src: srcSet[0].split(' ')[0],
        sizes: sizes,
        srcSet: srcSet.join(', '),
    };
};
exports.getProps = getProps;
